export function ReadOnlySupport(props) {
    const { readOnly, whenReadOnly, notReadOnly } = props;

    if (readOnly)
        return whenReadOnly();
    return notReadOnly();
}
